import getConfig from 'next/config';
import Cookie from 'js-cookie';

import { STORAGE } from 'shared/enums/SitePreferences';

export const checkGuestCohort = (serverSideCohort = '') => {
  const { publicRuntimeConfig } = getConfig();
  const cohort = serverSideCohort || Cookie.get(STORAGE.GUEST_CHECKOUT_COHORT);

  const threshold = publicRuntimeConfig.GUEST_CHECKOUT_COHORT;

  if (typeof cohort === 'undefined') {
    return false;
  }

  return Number(cohort) <= Number(threshold);
};
